import React from 'react'

interface CancelConfirmationModalProps {
    isOpen: boolean
    onCancel: () => void
    onContinue: () => void
}

export default function CancelConfirmationModal({ isOpen, onCancel, onContinue }: CancelConfirmationModalProps) {
    if (!isOpen) return null

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirmer l'annulation</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={onContinue}
                        >
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ? Les modifications seront perdues.</p>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onContinue}
                        >
                            Continuer l'édition
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={onCancel}
                        >
                            Quitter sans enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
